import { Observable } from "rxjs";
import { ObservableFromFetch } from "../ObservableFromFetch"
import Address from "./LocationModel/Address";

export default function LocationQueryGetObservable(query: string): Observable<Address[]> {
  const requestBody: string = JSON.stringify({ AutoCompleteString: query })
  return ObservableFromFetch<Address[]>("Order/SmartyStreetsAutoComplete", requestBody)
}
